import request from '@/utils/request'

const information = {
  name: 'information',
  state: {
    isInformationDetailLoading: false,
    informationDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_INFORMATION_DETAIL_LOADING: (state, data) => {
      state.isInformationDetailLoading = data
    },
    SET_MODULES_INFORMATION_DETAIL_DATA: (state, data) => {
      state.informationDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryInformationDetailData({ commit }, id) {
      commit('SET_IS_MODULES_INFORMATION_DETAIL_LOADING', true)
      commit('SET_MODULES_INFORMATION_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/information/informationDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_INFORMATION_DETAIL_LOADING', false)
          commit('SET_MODULES_INFORMATION_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_INFORMATION_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetInformationDetailData({ commit }) {
      commit('SET_MODULES_INFORMATION_DETAIL_DATA', {})
    },
    //  重置账号新增页面数据
    setInformationDetailData({ commit }, data) {
      commit('SET_MODULES_INFORMATION_DETAIL_DATA', data)
    }
  }
}

export default information
